import { FC } from 'react';
import { Box, BoxProps, Image, Text } from '@chakra-ui/react';
import { CbCard } from '../CbCard';
export interface CbMetricsCardProps extends BoxProps {
  image: string;
  metricName: string;
  metricValue: string;
}
export const CbMetricsCard: FC<CbMetricsCardProps> = ({
  image,
  metricName,
  metricValue,
  ...props
}) => {
  return <CbCard minHeight={32} maxWidth="sm" display="flex" alignItems={'center'} paddingX={4} flexGrow={1} {...props} data-sentry-element="CbCard" data-sentry-component="CbMetricsCard" data-sentry-source-file="CbMetricsCard.tsx">
      <Image height={16} src={image} marginRight={4} data-sentry-element="Image" data-sentry-source-file="CbMetricsCard.tsx" />
      <Box data-sentry-element="Box" data-sentry-source-file="CbMetricsCard.tsx">
        <Text fontSize="4xl" fontWeight="bold" color={'text.primaryDark'} data-sentry-element="Text" data-sentry-source-file="CbMetricsCard.tsx">
          {metricValue}
        </Text>
        <Text fontSize="md" color="text.secondary" data-sentry-element="Text" data-sentry-source-file="CbMetricsCard.tsx">
          {metricName}
        </Text>
      </Box>
    </CbCard>;
};